/**
 * Copyright (c) Grupo Valco, Inc. and its affiliates. All Rights Reserved.
 *
 * @date 2023-08-08
 * @author Ricardo Gaspar <ricardo.gaspar@grupo-valco.com>
 *
 */

function fill(s, scope) {
  return new Function('return ' + s).call(scope);
}

export default {
  fill,
};
